import { Button } from "@mui/material";
import { useMemo } from "react";
import { AuditTrailModel } from "../../../../Generated/Commodity-Management-Api";
import { StoneXLoading, StoneXRow } from "../../../StoneX";
import { StoneXModal } from "../../../StoneXMui";
import HistoricalNote from "./HistoricalNote";
import { timestampFromDateString } from "../../../../Helpers";

interface NoteHistoryModalProps {
  AuditTrailModels: AuditTrailModel[];
  open: boolean;
  isLoading: boolean;
  onClose: () => void;
}

export function NoteHistoryModal(props: NoteHistoryModalProps) {

  const { AuditTrailModels, open, isLoading, onClose } = props;
  
  const historicalNotes = useMemo(() => 
    AuditTrailModels
      .slice(0, -1)
      .map(({ date, user, properties: { subject, content } }) => ({
        date: timestampFromDateString(date),
        user,
        subject,
        content
      }))
  , [AuditTrailModels]);

  return <StoneXModal header={"Note History"} open={open} width={"80%"} onClose={onClose}>

  <StoneXLoading show={isLoading} />

  {!isLoading && historicalNotes.length === 0 && <>There is no note history.</>}

  {!isLoading && historicalNotes.length > 0 && <>
    {historicalNotes.map((auditEvent, index) => <HistoricalNote key={index} date={auditEvent.date} user={auditEvent.user} subject={auditEvent.subject} content={auditEvent.content} />)}
  </>}

  <StoneXRow justify="end" marginDirection='top'>
    <Button variant="outlined" onClick={onClose}>Close</Button>
  </StoneXRow>
</StoneXModal>
}